import { buildQueryString } from "./urlBuilder";

export function utmHotJob() {
	const utm = {
		utm_source_navi: 'vnw_homepage',
		utm_medium_navi: 'HotJob',
		utm_campaign_navi: 'HotJob',
		utm_term_navi: 'homepage2',
		source: 'homePage'
	}

	return buildQueryString(utm);
}

export function utmTopJob() {
	const utm = {
		utm_source_navi: 'vnw_homepage',
		utm_medium_navi: 'TopJob',
		utm_campaign_navi: 'TopJob',
		utm_term_navi: 'homepage2',
		source: 'homePage'
	}

	return buildQueryString(utm);
}

export function utmRecoJob(jobSource) {
	const utm = {
		utm_source_navi: 'vnw_homepage',
		utm_medium_navi: 'TopJobReco',
		utm_campaign_navi: 'TopJobReco',
		utm_content_navi: jobSource,
		utm_term_navi: 'homepage2',
		source: 'homePage'
	}

	return buildQueryString(utm);
}

export function utmHrInsider() {
	const utm = {
		utm_source_navi: 'vnw_homepage'
	}

	return buildQueryString(utm);
}

export function utmBestJobInCategory(catId) {
	const utm = {
		utm_source_navi: 'vnw_homepage',
		utm_medium_navi: 'YourCategories' //catId
	}

	return buildQueryString(utm);
}

export function utmPromotionJob() {
	const utm = {
		utm_source_navi: 'vnw_homepage',
		utm_medium_navi: 'FilterPromotion'
	}

	return buildQueryString(utm);
}
